<template>
  <v-card class="admin-events-card" elevation="4">
    <v-card-title>
      <h2 class="section-title">
        <v-icon left>mdi-monitor-dashboard</v-icon>
        Admin Events
      </h2>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$emit('send-notification')">
            <v-list-item-icon>
              <v-icon>mdi-bell</v-icon>
            </v-list-item-icon>
            <v-list-item-title>System-Benachrichtigung senden</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$emit('refresh-users')">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Nutzer-Refresh erzwingen</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-card-text>
      <!-- Event Log -->
      <div class="event-log">
        <v-timeline dense>
          <v-timeline-item
            v-for="(event, index) in events"
            :key="index"
            :color="getEventColor(event.type)"
            small
          >
            <template v-slot:opposite>
              <span class="event-time">{{ formatEventTime(event.timestamp) }}</span>
            </template>
            <v-card class="elevation-2" color="rgba(0, 0, 0, 0.3)">
              <v-card-text>
                <div class="event-type">{{ getEventLabel(event.type) }}</div>
                <div class="event-timestamp">
                  <v-icon x-small>mdi-clock-outline</v-icon>
                  {{ formatDetailedTime(event.timestamp) }}
                </div>
                <div class="event-description">{{ getEventDescription(event) }}</div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </div>
      
      <!-- Quick Actions -->
      <v-card flat class="mt-3 pa-3" color="rgba(255, 255, 255, 0.1)" dark>
        <div class="subtitle mb-2">Schnellaktionen</div>
        <v-row>
          <v-col cols="6">
            <v-btn
              block
              color="info"
              @click="$emit('broadcast')"
              :loading="broadcasting"
            >
              <v-icon left>mdi-broadcast</v-icon>
              Broadcast
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              block
              color="warning"
              @click="$emit('clear-events')"
            >
              <v-icon left>mdi-delete</v-icon>
              Events löschen
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AdminEvents',
  
  props: {
    events: {
      type: Array,
      default: () => []
    },
    broadcasting: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    getEventColor(type) {
      const colorMap = {
        'user-connected': 'success',
        'user-disconnected': 'error',
        'admin-action': 'info',
        'system': 'warning',
        'packlist-track-start': 'primary',
        'packlist-track-end': 'success',
        'packlist-multicart-slot': 'purple'
      };
      return colorMap[type] || 'grey';
    },
    
    getEventLabel(type) {
      const labelMap = {
        'user-connected': 'Nutzer verbunden',
        'user-disconnected': 'Nutzer getrennt',
        'admin-action': 'Admin Aktion',
        'system': 'System',
        'packlist-track-start': 'Packen gestartet',
        'packlist-track-end': 'Packen beendet',
        'packlist-multicart-slot': 'MultiCart Regal'
      };
      return labelMap[type] || type;
    },
    
    getEventDescription(event) {
      if (event.userId) {
        let desc = `Nutzer: ${event.userId}`;
        if (event.username) desc = `${event.username}`;
        if (event.orderNumber) desc += ` - Bestellung: ${event.orderNumber}`;
        if (event.location) desc += ` - Regal: ${event.location}`;
        return desc;
      }
      if (event.message) return event.message;
      return JSON.stringify(event.data || {});
    },
    
    formatEventTime(timestamp) {
      if (!timestamp) return '';
      return moment(timestamp).format('HH:mm');
    },
    
    formatDetailedTime(timestamp) {
      if (!timestamp) return '';
      return moment(timestamp).format('DD.MM HH:mm:ss');
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 1.2rem;
  font-weight: 500;
}

.admin-events-card {
  background: linear-gradient(135deg, rgba(30, 30, 30, 0.95) 0%, rgba(20, 20, 20, 0.95) 100%);
}

.event-log {
  max-height: 400px;
  overflow-y: auto;
}

.event-time {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
}

.event-type {
  font-weight: bold;
  font-size: 0.9rem;
}

.event-timestamp {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
  margin: 4px 0;
}

.event-description {
  font-size: 0.85rem;
}
</style>